import { useEffect, useState } from 'react';

export function useIsXSBreakpoint() {
	const [isXSBreakpoint, setisXSBreakpoint] = useState(() => window.innerWidth < 640);

	useEffect(() => {
		const handleResize = () => setisXSBreakpoint(window.innerWidth < 640);
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);
	return isXSBreakpoint;
}
